import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    loginPhone: "", //验证码登录手机号
    infoShow: false, //编辑素材弹窗标识
    articleShow: false, //素材编辑文章弹窗
    videoShow: false, //素材编辑视频弹窗
    infoData: {} //素材弹窗数据
  },
  mutations: {
    // 登录页手机号
    updatePhone(state, data) {
      state.loginPhone = data;
    },

    // 素材编辑弹窗
    updateInfoShow(state, data) {
      state.infoShow = data;
    },

    // 素材编辑文章弹窗
    updateArticleShow(state, data) {
      state.articleShow = data;
    },

    // 素材编辑视频弹窗
    updateVideoShow(state, data) {
      state.videoShow = data;
    },

    // 素材编辑数据
    changeInfoData(state, data) {
      state.infoData = data;
    }
  },
  actions: {},
  modules: {}
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js